import React from 'react';
import { useCurrentFrame, useVideoConfig } from 'remotion';
import { LayerWrapper } from './LayerWrapper';
import type { TickerLayer as TickerLayerConfig } from '../../types';

interface TickerLayerProps {
  layer: TickerLayerConfig;
  tickerText: string;
}

export function TickerLayer({ layer, tickerText }: TickerLayerProps) {
  const frame = useCurrentFrame();
  const { width } = useVideoConfig();

  const { position, animation, opacity, backgroundColor, speed, separatorChar, font } = layer;

  const text = tickerText
    ? `${tickerText}${separatorChar}${tickerText}${separatorChar}`
    : `Latest News${separatorChar}Stay tuned for updates${separatorChar}`;

  // Start scrolling after enter animation completes
  const scrollStartFrame = animation.enterDelay + animation.enterDuration;
  const scrolledFrames = Math.max(0, frame - scrollStartFrame);
  const offsetX = width - speed * scrolledFrames;

  return (
    <LayerWrapper position={position} animation={animation} opacity={opacity} overflow="hidden">
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor,
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            whiteSpace: 'nowrap',
            transform: `translateX(${offsetX}px)`,
            fontFamily: font.fontFamily,
            fontSize: font.fontSize,
            fontWeight: font.fontWeight,
            color: font.color,
            letterSpacing: font.letterSpacing,
            lineHeight: 1,
          }}
        >
          {text}
        </div>
      </div>
    </LayerWrapper>
  );
}
